import React, { FC } from 'react';
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import BodyRow from './components/BodyRow';
import { Skeleton } from '@material-ui/lab';

interface Props {
  isLoadingData: boolean;
  isUpdate: boolean;
  checkedInvoice: InvoiceModel[];
  paymentMultiple: { PurchaseInvoiceId: number; totalPay: number }[];
  handleIndividualCheck: (item: { InvoiceId: number }) => void;
}

const InvoiceTable: FC<Props> = props => {
  const { isLoadingData, isUpdate, checkedInvoice, paymentMultiple, handleIndividualCheck } = props;
  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell align='center'></TableCell>
            <TableCell align='center'>Nomor Invoice</TableCell>
            <TableCell align='center'>Tgl Pelunasan</TableCell>
            <TableCell align='center'>Total Jumlah</TableCell>
            <TableCell align='center'>Total Pembayaran</TableCell>
            <TableCell align='center'>Sisa Pembayaran</TableCell>
            {/* <TableCell align='center'>Dibayarkan</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            <TableRow>
              <TableCell colSpan={6} align='center'>
                <Skeleton />
              </TableCell>
            </TableRow>
          ) : checkedInvoice.length > 0 ? (
            checkedInvoice.map((value, index) => (
              <BodyRow
                key={index}
                index={index}
                invoice={value}
                isLoading={isLoadingData}
                isUpdate={isUpdate}
                totalPay={paymentMultiple.find(v => v.PurchaseInvoiceId === value.id)?.totalPay ?? 0}
                handleIndividualCheck={handleIndividualCheck}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align='center'>
                Invoice belum tersedia
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTable;
